"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendedProduct2View = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const Wrap = (0, app_1.styled)(ui_1.Stack) `
  width: 100%;
`;
const MinHeightImg = (0, app_1.styled)(app_1.Image) `
  min-height: 25rem;
  width: 100%;
`;
const StyledLink = (0, app_1.styled)(app_1.Link) `
  width: 100%;
`;
function RecommendedProduct2View({ id, img, title, }) {
    const productPath = (0, app_1.useContextPath)('ecommerce.product');
    const path = `${productPath}/${id}`;
    return ((0, jsx_runtime_1.jsx)(app_1.AssetsProvider, Object.assign({ path: path }, { children: (0, jsx_runtime_1.jsx)(StyledLink, Object.assign({ href: path }, { children: (0, jsx_runtime_1.jsxs)(Wrap, Object.assign({ kind: "vertical" }, { children: [(0, jsx_runtime_1.jsx)(MinHeightImg, { img: img }), (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span" }, { children: title }))] })) })) })));
}
exports.RecommendedProduct2View = RecommendedProduct2View;
